(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("prettier"));
	else if(typeof define === 'function' && define.amd)
		define(["prettier"], factory);
	else if(typeof exports === 'object')
		exports["prettierPluginSolidity"] = factory(require("prettier"));
	else
		root["prettierPlugins"] = root["prettierPlugins"] || {}, root["prettierPlugins"]["solidity"] = factory(root["prettier"]);
})(
        typeof globalThis !== "undefined"
          ? globalThis
          : typeof global !== "undefined"
          ? global
          : typeof self !== "undefined"
          ? self
          : this || {}
      , function(__WEBPACK_EXTERNAL_MODULE__3130__) {
return 